import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import React from "react";

import { GoToShopSettingsCTA } from "./ctas";
import { OrderMinimumsIA } from "./instantAnswersComponents/myShop/OrderMinimumsIA";

export const OrderMinimums: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => getAnswer(context, strictLocalize).getTitle(),
  descriptionBuilder: (context) =>
    getAnswer(context, strictLocalize).getDescription(),
  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.getLink?.();
    },
  },
});

const getAnswer = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => ORDER_MINIMUMS_TITLE(strictLocalize),
    getDescription: () => ORDER_MINIMUMS_DESCRIPTION(context),
  };
};

const ORDER_MINIMUMS_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Setting order minimums",
    description: {
      text: "Title for the answer of how to set order minimums in the brand portal",
    },
  });

const getPrimaryCTA: CtaBuilderFn = (_context, strictLocalize) =>
  GoToShopSettingsCTA(strictLocalize);

const ORDER_MINIMUMS_DESCRIPTION = (_context: InstantAnswerContext) => (
  <OrderMinimumsIA />
);
